import { DockDesignTokens } from '@primeuix/themes/types/dock';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/dock/index.ts
const dk = componentCommon.dock;

export const DockTelekomDT: DockDesignTokens = {
  root: {
    background: t(dk.background),
    borderColor: t(dk.border.color),
    padding: t(dk.padding),
    borderRadius: t(dk.border.radius),
  },
  item: {
    borderRadius: t(dk.item.border.radius),
    padding: t(dk.item.padding),
    size: t(dk.item.size),
    focusRing: {
      width: t(dk.item.focus.ring.width),
      color: t(dk.item.focus.ring.color),
      offset: t(dk.item.focus.ring.offset),
    },
  },
};
